import { Injectable } from '@angular/core';

import { Query, gql } from 'apollo-angular';

import { LocalizableNameArgs, StoreConfiguration } from '@hdms/shared/common-types';

export interface FavoritesConfigurationResponse {
  storeConfiguration: StoreConfiguration;
}

@Injectable({
  providedIn: 'root'
})
export class FavoritesConfigurationGqlService extends Query<FavoritesConfigurationResponse, LocalizableNameArgs> {
  override document = gql`
    query FavoritesConfiguration($localization: LocalizationInput!) {
      storeConfiguration(localization: $localization) {
        id
        common {
          fireStopSubmittals
          recommendedProducts
          recentlyPurchasedItems
        }
      }
    }
  `;
}
